import React from 'react';
import {Route, Redirect} from 'react-router';
import {makeSiblings} from 'lib/makeSiblings';
import awaitMandarkQueries from 'lib/hocs/awaitMandarkQueries';
import {getDoesUserBelongToAnyLicensedClassroomsQuery} from 'lib/UserAccessUtil';

import sessionStore from 'client/Session/SessionStore';
import {getFolderQuestionSetsQuery} from 'client/FolderPracticeView/folderPracticeView.queries';

import CreateAssignmentWrapper from './CreateAssignmentWrapper.react';
import createAssignmentStore from './CreateAssignment.store';
import SecondaryHeader from './shared/SecondaryHeader';

function requireTeacherStatus(nextState, replace) {
  if (process.env.IS_BROWSER) {
    if (!sessionStore.isTeacher()) {
      replace('/', null);
    }
  }
}

function withSecondary(Component) {
  return makeSiblings(SecondaryHeader, Component);
}

const CreateAssignmentWrapperWithSecondary = withSecondary(CreateAssignmentWrapper);

export default (
  <Route
    component={withSecondary()}
    name='create-assignment'
    onEnter={requireTeacherStatus}
    path='create-assignment'
    title='Create an Assignment | Albert.io'
  >
    <Route
      path='new-assignment'
      onEnter={requireTeacherStatus}
      component={awaitMandarkQueries(() => {
        return {
          queries: {
            licensedSubjects: getDoesUserBelongToAnyLicensedClassroomsQuery(true)
          }
        };
      }, CreateAssignmentWrapperWithSecondary)}
    />

    <Route
      path='subject/:subjectSlug/topic/:topicSlug'
      onEnter={requireTeacherStatus}
      component={awaitMandarkQueries(({params}) => {
        return {
          queries: {
            licensedSubjects: getDoesUserBelongToAnyLicensedClassroomsQuery(true),
            questionSets: createAssignmentStore.getQueryForSubjectSlug(params)
          }
        };
      }, CreateAssignmentWrapperWithSecondary)}
    />
    <Route
      path='subject/:subjectSlug/topic/:topicSlug/question-set/:questionSetSlug'
      onEnter={requireTeacherStatus}
      component={awaitMandarkQueries(({params}) => {
        return {
          queries: {
            licensedSubjects: getDoesUserBelongToAnyLicensedClassroomsQuery(true),
            questionSets: createAssignmentStore.getQueryForSubjectSlug(params)
          }
        };
      }, CreateAssignmentWrapperWithSecondary)}
    />
    <Route
      path='folder/:folderId'
      onEnter={requireTeacherStatus}
      component={awaitMandarkQueries(({params}) => {
        const queries = {
          folder: createAssignmentStore.getQueryForFolder(params),
          licensedSubjects: getDoesUserBelongToAnyLicensedClassroomsQuery(true)
        };
        if (global.window.location.search) {
          queries.folderQuestionSets = getFolderQuestionSetsQuery(params.folderId, 'infinite');
        }
        return {
          queries
        };
      }, CreateAssignmentWrapperWithSecondary)}
    />
    <Route
      path='assessment/:examId'
      onEnter={requireTeacherStatus}
      component={awaitMandarkQueries(({params}) => {
        return {
          queries: {
            licensedSubjects: getDoesUserBelongToAnyLicensedClassroomsQuery(true),
            assessment: createAssignmentStore.getQueryForAssessment(params)
          }
        };
      }, CreateAssignmentWrapperWithSecondary)}
    />
    <Redirect from='practice-exam/:examId' to='assessment/:examId' />
    <Route
      path='assignment/:assignmentId/classroom/:classroomId/edit'
      onEnter={requireTeacherStatus}
      component={awaitMandarkQueries(({params}) => {
        return {
          queries: {
            licensedSubjects: getDoesUserBelongToAnyLicensedClassroomsQuery(true),
            assignment: createAssignmentStore.getQueryForAssignment(params)
          }
        };
      }, CreateAssignmentWrapperWithSecondary)}
    />
  </Route>
);
